module.exports = __webpack_public_path__ + "static/media/fundo.4b44ce0e.png";